import React, {useState} from "react";

import ossUpload from "../../units/ossUpload";
import {postResumePhotoModify} from "../../service";
import {useHistory} from "react-router-dom";
import {useLoading} from "../../components/loading/LoadingProvider";
import AvatarEditor from "./avatarEditor";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";



function PhotoPage() {
    const userData = useUserInfo()
    const [input, setInput] = useState<File | null>()
    const [editorFile, setEditorFile] = useState<Blob>()
    const [imgUrl, setImgUrl] = useState<string | null>(userData && userData.photo ? userData.photo : null)
    const loading = useLoading()
    const his = useHistory()
    const dispatch = useDispatch()


    const fileChange = (e: any) => {
        setInput(e.currentTarget.files[0])
    }

    const EditorHandle = (res: any) => {
        if (res) {
            setImgUrl(URL.createObjectURL(res))
            res.name = 'photo.jpg'
            setEditorFile(res)
        }
        setInput(null)
    }

    const imgOnLoad = () => {
        if (editorFile && imgUrl) {
            URL.revokeObjectURL(imgUrl)
        }
    }

    const upLoadFile = () => {
        if (editorFile && userData) {
            loading.showLoading()
            ossUpload(editorFile).then((res: any) => {
                if (res.code === 1) {
                    postResumePhotoModify({
                        userId: userData.id,
                        photo: res.data
                    }).then(data => {
                        if (data.code === 1) {
                            // addToast('上传成功', {appearance: 'success'})
                            dispatch(userInfoAction(Object.assign({},userData,{photo:res.data})))
                            loading.showSuccess('上传成功',() => {
                                his.goBack()
                            })


                        } else {
                            loading.showError('上传失败')
                            // addToast('上传失败', {appearance: 'error'})
                        }
                    }).catch(e => {
                        loading.showError('上传失败')
                    })
                }
            }).catch(res => {
                loading.showError('上传失败')
            })
        }
    }


    return <div className="avatar-page resume">
        {
            imgUrl && <div className="avatar-box">
                <img src={imgUrl} onLoad={imgOnLoad} alt=""/>
                {/*<img src={imgUrl} className='shadow' alt=""/>*/}
            </div>
        }

        {
            editorFile && <div className="upload-file" onClick={upLoadFile}>上传简历照片</div>
        }

        <label htmlFor={'file'} className="btn selectImage">更换简历照片</label>

        {
            input && <AvatarEditor file={input} onChoose={EditorHandle}/>
        }

        <input type="file" accept={'image/*'} onChange={fileChange} style={{display: 'none'}} id='file'/>
    </div>
}

export default PhotoPage
